function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "#008AC6",
  fillRule: "nonzero",
  rx: 2.206
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M9.81261114 9.51882536L5.21974377.261225533C5.15462489.129891061 5.02182626.0470403701 4.8765892.0470403701L.392113941.0470403701C.10644795.0470403701-.0791356467.351372584.0490116295.609706009L6.72740798 14.0709077C6.86449211 14.3471648 7.2502405 14.3585852 7.40305561 14.0908934L8.58063082 12.0273984 9.80200188 9.88723864C9.86654588 9.77403932 9.87057008 9.63561998 9.81261114 9.51882536M16.5149541 9.51882536L11.9220345.261225533C11.8569156.129891061 11.724117.0470403701 11.5789322.0470403701L7.0944569.0470403701C6.8087909.0470403701 6.62320731.351372584 6.75135458.609706009L13.4297509 14.0709077C13.5668351 14.3471648 13.9525835 14.3585852 14.1053986 14.0908934L15.2829215 12.0273984 16.5043448 9.88723864C16.5688888 9.77403932 16.5728608 9.63561998 16.5149541 9.51882536",
  transform: "translate(6.716 7.612)"
}));

function SvgWorkflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.8f31e5e0.svg";
export { ForwardRef as ReactComponent };